<template>
    <div>
        <top-carousel></top-carousel>
        <div class="aboutCont clearfix">
            <div class="container clearfix">
                <ul>
                    <li class="right">
                        <div class="pic">
                            <img
                                src="../../../../assets/img/companyIntro/c2.png"
                                alt=""
                            />
                        </div>
                    </li>

                    <li class="left">
                        <div class="aboutContHead">
                            <h3>WHO ARE WE</h3>

                            <h2><span>西安锦威电子科技有限公司</span></h2>
                        </div>

                        <div class="aboutTxt">
                            <p>
                                西安锦威电子科技有限公司是一家专注于智慧控制、节能减排、数字化管理领域的高新技术企业。
                            </p>
                            <p>
                                企业拥有70多人的研发和实施团队，在这一领域，为用户提供设计、研发、实施、运维、改造升级等全生命周期的解决方案。
                            </p>
                            <p>
                                我们的产品体系包括自动化系统、数字化系统、建筑智能化系统、能源管理系统。
                            </p>
                            <p>
                                自动化系统助力不同类型的用户实现环境参数、工艺参数、工艺流程的自动化控制。在环境参数控制要求严格的生物安全实验室、动物SFP实验室、理化实验室、生物安全三级防护车间，我们积累了丰富的实施经验，获得了多项软件著作权。
                            </p>
                        </div>
                    </li>
                </ul>
                <ul>
                    <li class="left">
                        <div class="pic">
                            <img
                                src="../../../../assets/img/companyIntro/s2.png"
                                alt=""
                            />
                        </div>
                    </li>

                    <li class="right" style="margin-top: -10px">
                        <div class="aboutTxt">
                            <p>
                                数字化系统从自动化底层的生产管控、质量控制、设备控制、能耗和物料监测到顶层的设备级、系统级和产业级制造、产品全生命周期、设备全生命周期仿真及分析，并将结果反馈回系统，降低生产的不确定性因素，推动了企业提质增效降本。
                            </p>
                            <p>
                                建筑智能化系统针对办公、商业、住宅、工厂、医院、展馆等不同类型的建筑，提供安全防范智能化、通讯自动化、楼宇管理自动化、信息化等智能化全部子系统的设计、软件开发、工程施工、系统调试及交付、运维管理。
                            </p>
                            <p>
                                能源管理系统能够自动的针对不同类型的公共建筑、动力站房耗能特点、进行节能分析，挖掘节能空间，提出恰当的节能策略和控制措施。结合锦威电子专业积累，为用户节能30%以上。
                            </p>
                            <p>
                                企业成立至今的10年，我们已经为上百客户提供了量身定制的控制、节能、管理解决方案。领域涉及：航空制造、烟草生产、半导体生产、人用药品生产、兽用药品生产、商业建筑、住宅建筑、高等学府、研究所。
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.aboutCont {
    background: #fff;
    padding: 60px 0;
}
.aboutCont li.left {
    float: left;
    width: 50%;
    margin-bottom: 15px;
    img {
        width: 100%;
        height: 436px;
    }
}
.aboutCont li.right {
    float: right;
    width: 50%;
    margin-bottom: 15px;
    img {
        width: 100%;
        height: 436px;
    }
}
.aboutContHead {
    width: 82%;
    margin: 10px auto 30px;
    text-align: center;
}
.aboutContHead h3 {
    letter-spacing: 10px;
    color: #333;
}
.aboutContHead h2 {
    font-size: 28px;
    color: #0382db;
    position: relative;
    z-index: 1;
}
.aboutContHead h2 span {
    display: inline-block;
    padding: 0 20px;
    background: #fff;
    position: relative;
    z-index: 4;
}

.aboutContHead h2:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #e1e1e1;
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 1;
}

.aboutTxt {
    padding: 0 30px;
}

.aboutTxt p {
    font-size: 15px;
    text-indent: 2em;
    line-height: 33.5px;
    color: #666;
}
</style>
